import { render, staticRenderFns } from "./ReservationType.vue?vue&type=template&id=f6b89d7a&"
import script from "./ReservationType.vue?vue&type=script&lang=js&"
export * from "./ReservationType.vue?vue&type=script&lang=js&"
import style0 from "./ReservationType.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports